// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","company":"Footer_company__B3nWt","info":"Footer_info__2OKti","map":"Footer_map__VY92u"};